import {
    ListItem,
    ListItemButton,
    ListItemIcon,
    Stack,
    SxProps,
    Theme,
    Typography,
    useMediaQuery,
} from '@mui/material'
import { FC, MouseEventHandler, PropsWithChildren, ReactNode } from 'react'
import { OnboardingTooltip } from '../../../../components/Wrapper/NavigationSidebar/components/OnboardingTooltip'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { theme } from '../../../../theme'

type Props = PropsWithChildren<{
    startIcon?: ReactNode
    endIcon?: ReactNode
    additionalContent?: ReactNode
    textColor?: string
    sx?: SxProps<Theme>
    onClick?: MouseEventHandler<HTMLDivElement>
    shouldCloseSidebar?: boolean
    disabled?: boolean
    isActive?: boolean
}>

export const NavigationButton: FC<Props> = ({
    onClick,
    startIcon,
    children,
    endIcon,
    additionalContent,
    textColor = '#181B25',
    sx,
    disabled,
    shouldCloseSidebar = true,
    isActive,
    isOnboardingTooltip = false,
    isProjectStepOnboarding = false,
}) => {
    const { setOpenSidebar, stepOnboarding } = useWrapperStore((state) => state)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const isStepOnboarding = stepOnboarding === 2 || stepOnboarding === 4

    const handleClick: MouseEventHandler<HTMLDivElement> = (e) => {
        onClick?.(e)
        setOpenSidebar(!shouldCloseSidebar)
    }

    return isOnboardingTooltip && stepOnboarding === 2 ? (
        <OnboardingTooltip
            placement="right-start"
            open={!isMobile && isOnboardingTooltip && stepOnboarding === 2}
            title="Ассистенты"
            decription="Более 20 готовых чат-ботов экспертов с ролями (репетитор, фитнес-тренер, нутрициолог, психолог и др.). Они сразу работают для тебя без сложных настроек">
            {' '}
            <ListItem
                sx={{
                    borderRadius: ' 12px',
                    background:
                        stepOnboarding === 2 && isOnboardingTooltip
                            ? '#EBF5FD !important'
                            : stepOnboarding === 2 || stepOnboarding === 4
                              ? '#7f7f7f'
                              : '#fff',
                    p: 0,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                <ListItemButton
                    disabled={disabled || stepOnboarding !== 100}
                    onClick={handleClick}
                    sx={{
                        opacity: stepOnboarding !== 100 ? '1 !important' : 'inherit',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: 0,
                        borderRadius: '12px',
                        backgroundColor: isActive
                            ? (stepOnboarding === 2 && isOnboardingTooltip) || stepOnboarding === 4
                                ? '#f7f7f7'
                                : '#F5F5F5'
                            : 'transparent',
                        ...sx,
                    }}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={1}
                        sx={{
                            p: 1,
                            pr: 0,
                            minWidth: '0',
                            boxSizing: 'border-box',
                        }}>
                        {startIcon && (
                            <ListItemIcon
                                sx={{
                                    minWidth: 'unset',
                                    color: '#5A5F72',
                                }}>
                                {startIcon}
                            </ListItemIcon>
                        )}
                        <Typography
                            variant="body2"
                            color={textColor}
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}>
                            {children}
                        </Typography>
                    </Stack>
                    {endIcon}
                </ListItemButton>
                {additionalContent}
            </ListItem>
        </OnboardingTooltip>
    ) : (
        <ListItem
            sx={{
                borderRadius: ' 12px',
                background:
                    stepOnboarding === 2 && isOnboardingTooltip
                        ? '#EBF5FD !important'
                        : stepOnboarding === 2 || stepOnboarding === 4
                          ? '#7f7f7f'
                          : '#fff',
                p: 0,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
            <ListItemButton
                disabled={disabled || stepOnboarding !== 100}
                onClick={handleClick}
                sx={{
                    opacity: stepOnboarding !== 100 ? '1 !important' : 'inherit',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    p: 0,
                    borderRadius: '12px',
                    backgroundColor: isActive
                        ? (stepOnboarding === 2 && isOnboardingTooltip) || stepOnboarding === 4
                            ? '#f7f7f7'
                            : '#F5F5F5'
                        : 'transparent',
                    ...sx,
                }}>
                <Stack
                    direction="row"
                    alignItems="center"
                    gap={1}
                    sx={{
                        p: 1,
                        pr: 0,
                        minWidth: '0',
                        boxSizing: 'border-box',
                    }}>
                    {startIcon && (
                        <ListItemIcon
                            sx={{
                                minWidth: 'unset',
                                color: '#5A5F72',
                            }}>
                            {startIcon}
                        </ListItemIcon>
                    )}
                    <Typography
                        variant="body2"
                        color={textColor}
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}>
                        {children}
                    </Typography>
                </Stack>
                {endIcon}
            </ListItemButton>
            {additionalContent}
        </ListItem>
    )
}
